export default {
  flashSalesTag: {
    id: 'flash_sales_product_card_tag_new',
    defaultMessage: 'Flash deal',
  },
  competitiveFlashSalesTag: {
    id: 'competitive_price_product_card_tag',
    defaultMessage: 'Great price',
  },
  sellerFlashSalesTag: {
    id: 'seller_flash_sales_product_card_tag_new',
    defaultMessage: 'Price drop',
  },
} as const
